export default "__VITE_ASSET__65e8e8a6__"